export function validateQuizJSON(obj) {
  if (!obj || typeof obj !== "object") return { valid: false, error: "Config must be an object" };
  const questions = obj.questions;
  if (!Array.isArray(questions) || questions.length === 0) {
    return { valid: false, error: "questions must be a non-empty array" };
  }
  for (let i = 0; i < questions.length; i += 1) {
    const q = questions[i];
    if (!q || typeof q !== "object") return { valid: false, error: `Question ${i + 1} must be an object` };
    const text = q.text ?? q.question;
    if (!text || typeof text !== "string") return { valid: false, error: `Question ${i + 1} missing text` };
    if (!Array.isArray(q.options) || q.options.length < 3 || q.options.length > 5) {
      return { valid: false, error: `Question ${i + 1} must have 3-5 options` };
    }
    const correct = q.correct ?? q.correctAnswer;
    if (correct === undefined || correct === null || correct === "") return { valid: false, error: `Question ${i + 1} missing correct answer` };
    const isIndex = Number.isInteger(correct) && correct >= 0 && correct < q.options.length;
    const isValue = typeof correct === "string" && q.options.includes(correct);
    if (!isIndex && !isValue) return { valid: false, error: `Question ${i + 1} correct must be option index or value` };
    if (q.credit !== undefined && (!Number.isFinite(q.credit) || q.credit < 0)) {
      return { valid: false, error: `Question ${i + 1} credit must be a positive number` };
    }
  }
  return { valid: true, error: null };
}

export function computeScore(answers, questions) {
  let score = 0;
  for (let i = 0; i < questions.length; i += 1) {
    const q = questions[i];
    const correctField = q.correct ?? q.correctAnswer;
    const correctVal = Number.isInteger(correctField) ? q.options[correctField] : correctField;
    const id = q.id ?? `q${i}`;
    if (answers[id] === correctVal) {
      const credit = q.credit != null ? q.credit : 100 / questions.length;
      score += credit;
    }
  }
  return Math.round(score);
}
